import React from 'react';
import { connect } from 'react-redux';

import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { RichTextTile } from 'components/no-auth/common/RichTextTile/RichTextTile';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const PrivacyPolicyPage = (props) => {
    return (
        <>
            {props.heroTitle && <HeroSection title={props.heroTitle} data={props.heroData} btnVariant="primary" noIconBtn />}
            <ColoredSectionContainer dimension="average">{props.content && <RichTextTile text={props.content} />}</ColoredSectionContainer>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        heroTitle: state.extra?.strapiApi?.hero_block?.title,
        heroData: state.extra?.strapiApi?.hero_block,
        content: state.extra?.strapiApi?.privacy_policy_content,
    };
};

export default connect(mapStateToProps)(NotAuthBasePage(PrivacyPolicyPage));
